// extracted by mini-css-extract-plugin
export var highlights = "highlights-module--highlights--gsoB1";